import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private _router: Router, private toastr: ToastrService) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("can activate")
    if (sessionStorage.getItem('autho_token')) {
      return true;
    }
    else {
      this.toastr.error("Session got Expired Please Login again.")
      this._router.navigate(['']);
      return false;
    }
  }

}
